// Converts the legacy tracker shape ({ p1, p2, score1, score2, … }) into
// { home, away, homeScore, awayScore, createdAt, … }. p1 is HOME: the old form
// listed Home first. Stat fields, difficulty and stored ovr are dropped. Tied or
// orphaned games are skipped and reported; near-duplicates are reported and kept.

export function migrateLegacy(legacyPlayers, legacyGames, { p1Is = 'home', defaultInnings = 9 } = {}) {
  const p1IsHome = p1Is === 'home';
  const players = legacyPlayers
    .filter((player) => player && player.id != null && String(player.name || '').trim())
    .map((player) => ({ id: String(player.id), name: String(player.name).trim() }));
  const known = new Set(players.map((player) => player.id));
  const skipped = [];
  const games = [];

  legacyGames.forEach((game) => {
    if (!game || game.id == null) return;
    const id = String(game.id);
    const p1 = String(game.p1);
    const p2 = String(game.p2);
    if (!known.has(p1) || !known.has(p2)) {
      skipped.push({ id, reason: 'unknown player' });
      return;
    }
    const score1 = Number(game.score1) || 0;
    const score2 = Number(game.score2) || 0;
    if (score1 === score2) {
      skipped.push({ id, reason: 'tied score' });
      return;
    }
    const createdAt = typeof game.id === 'number' ? game.id : Number(game.id) || Date.parse(game.date) || 0;
    games.push({
      id: `g${id}`,
      createdAt,
      home: p1IsHome ? p1 : p2,
      away: p1IsHome ? p2 : p1,
      homeScore: p1IsHome ? score1 : score2,
      awayScore: p1IsHome ? score2 : score1,
      innings: Number(game.innings) || defaultInnings,
      date: typeof game.date === 'string' ? game.date : '',
    });
  });

  const sorted = [...games].sort((a, b) => a.createdAt - b.createdAt);
  const possibleDuplicates = [];
  for (let i = 1; i < sorted.length; i += 1) {
    const a = sorted[i - 1];
    const b = sorted[i];
    const same =
      a.home === b.home && a.away === b.away && a.homeScore === b.homeScore && a.awayScore === b.awayScore;
    if (same && b.createdAt - a.createdAt < 60000) {
      possibleDuplicates.push({
        first: a.id,
        second: b.id,
        secondsApart: Math.round((b.createdAt - a.createdAt) / 100) / 10,
      });
    }
  }

  return {
    players,
    games,
    report: { players: players.length, games: games.length, skipped, possibleDuplicates },
  };
}
